// extracted by mini-css-extract-plugin
export default {"error":"lPLVmEK19HiMEVPjZVCi","message":"tREONN5u4dpImTG0GTUs","text":"KTJ4Mxa7bWRTyovxJq4F","text-content":"aFuRxpSyLw5PILruOPUh","phone":"_fFNbXrf3tKcnDRvdHLD"};